import { useEffect, useState } from "react";
import TodayIcon from "@mui/icons-material/Today";
import edit from "../../assets/orders/editorder.svg";
import schedule from "../../assets/orders/clock.svg";
import prescription from "../../assets/tasks/Noteform.svg";
import addicon from "../../assets/orders/carbon_add.svg";
import ArticleIcon from "@mui/icons-material/Article";
import { Backdrop, CircularProgress, Switch } from "@mui/material";
import NavButtons from "../nav/navbuttons";
import EditPopup from "../popups/editpopup";
import AddNotesPopup from "../popups/addnotes";
import NewRxPopup from "../popups/newrx";
import api from "../../api/api";
import { useNavigate, useParams } from "react-router-dom";
import LabsNavButtons from "../nav/labsbuttons";
import ToastMessage from "../../utils/mui/righttoptoast";
import { useDispatch, useSelector } from "react-redux";
import { setSearchResults } from "../../reduxtoolkit/orders/universalsearch";
import MrecordButtons from "../nav/mrecordsbuttons";
import { updatelovValue, updateTovValue } from "../../reduxtoolkit/dump";
import {
  collapseIcon,
  expandIcon,
  notesIcon,
  pendingIcon,
  penIcon,
  prescriptionIcon,
  RXIcon,
  scheduledIcon,
  todayIcon,
} from "./svg";
import { COMPLETEDIcon, CROSSIcon } from "../../landingscreen/modals/svgs";
import dayjs from "dayjs";

const MedicalRecordsTab = ({
  data,
  appointmentId,
  setShowOrders,
  selectedSuggestionList,
  getordersData,
  referals,
  startDate,
  suggestionData,
  fetchsuggestions,
  selectedCard,
  SetSelectedCard,
}) => {
  const [isActive, setIsActive] = useState(false);
  const practiseid = window.getPracticeId();
  const [activeButton, setActiveButton] = useState(3);
  const navigate = useNavigate();
  const [isEditPopupOpen, setIsEditPopupOpen] = useState(false);
  // const [selectedSuggestionList,setSelectedSuggestionList]=useState([])
  // const [getordersData,setGetOrdersData]=useState([])
  // const [suggestionData,setSuggestionsData]=useState([])
  const [isAddnotesPopup, setAddNotesPopup] = useState(false);
  const [selectedEdit, setSelectedEdit] = useState("t");
  // const [selectedCard,SetSelectedCard]=useState('f')
  const [alertmessage, setAlertMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const [open, setOpen] = useState(false);
const params = useParams();

const id = params.id || appointmentId;
const dt = params.dt || startDate;
  const searchResults = useSelector(
    (state) => state.universalsearcher.searchResults
  );
  const [selectedButtons, setSelectedButtons] = useState([]);
  // const [referals,setReferals]=useState([])
  const lovValue = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "lov")?.value
  );
  const lov2Value = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "lov2")?.value
  );
  const tov2Value = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "tov2")?.value
  );
  const tovValue = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "tov")?.value
  );
  const [loading, setLoading] = useState(false);
  const [expandedCards, setExpandedCards] = useState({
    today: false,
    scheduled: false,
    prescriptions: false,
    notes: false,
  });

  const toggleCardExpansion = (cardName) => {
    setExpandedCards((prev) => ({
      ...prev,
      [cardName]: !prev[cardName],
    }));
  };

  // Badge count logic
  const todayItems = [
    ...(selectedSuggestionList?.filter((d) => d.schedule === "f") ?? []),
    ...(referals ?? []),
  ];

  // Which statuses count as inactive
  const completedOrCancelled = ["COMPLETED", "CANCELLEDTASK"];

  // Are ALL items inactive?
  const allInactive =
    todayItems.length > 0 &&
    todayItems.every((item) =>
      completedOrCancelled.includes(String(item?.status).toUpperCase())
    );

  // Pending = not completed/cancelled
  const pendingItems = todayItems.filter(
    (item) => !completedOrCancelled.includes(String(item?.status).toUpperCase())&&item.context!== "Tov"
  );

  // Decide the badge number
  const badgeCount = allInactive ? todayItems.length : pendingItems.length;

  // Scheduled items logic
  const scheduledItems =
    selectedSuggestionList?.filter((d) => d.schedule === "t") ?? [];
  const scheduledCompletedOrCancelled = scheduledItems.every((item) =>
    completedOrCancelled.includes(String(item?.status).toUpperCase())
  );
  const scheduledPendingItems = scheduledItems.filter(
    (item) => !completedOrCancelled.includes(String(item?.status).toUpperCase())
  );
  const scheduledBadgeCount =
    scheduledCompletedOrCancelled && scheduledItems.length > 0
      ? scheduledItems.length
      : scheduledPendingItems.length;

  // Prescriptions items logic
  const prescriptionItems = getordersData?.rx_recipe ?? [];
  const prescriptionBadgeCount = prescriptionItems.length; // Prescriptions don't have status, so show all

  // Notes items logic
  const notesItems = getordersData?.notes ?? [];
  const notesBadgeCount = notesItems.length; // Notes don't have status, so show all
  const [isnewRxpopup, setNewRxPopup] = useState(false);
  const dispatch = useDispatch();
  const handlealert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  // const getorders=async(x)=>{
  //   try {

  //     const selectedsuggestions = await api.post(`/v1/${practiseid}/orders/patient/${data.patientid}/get-orders`, {
  //         "appointmentid": data.appointmentid,
  //         // "orderdate": data.created_at ? new Date(data.created_at).toISOString().split('T')[0] : "Invalid date"
  //          "orderdate": dt && dt.includes(' ') && !isNaN(Date.parse(dt.split(' ')[0]))
  //          ? dt.split(' ')[0]
  //          : new Date().toISOString().split('T')[0]
  //     });
  //       if (selectedsuggestions.status === 200) {
  //             const lovtovItem = selectedsuggestions?.data?.lovtov?.[0];
  // if(!x){

  // if (lovtovItem) {
  //   dispatch(updatelovValue(lovtovItem.lov));
  //   dispatch(updateTovValue(lovtovItem.tov));
  // } else {
  //   // Optional: set defaults if needed
  //   dispatch(updatelovValue(null));
  //   dispatch(updateTovValue(null));
  // }

  // }

  //         const suggestionList = selectedsuggestions.data?.look || [];
  //         setGetOrdersData(selectedsuggestions?.data)
  //         setSelectedSuggestionList(suggestionList);
  //         setReferals(selectedsuggestions.data?.referrals || [])
  //         return selectedsuggestions?.data
  //       }

  //   } catch (error) {
  //     console.log(error)
  //   }

  // }
  const userConfig = useSelector((state) => state.userconfig);
  const selectsuggestion = async (order) => {
    setLoading(true);
    try {
      const createResponse = await api.post(
        `/v1/${practiseid}/patient/${data.patientid}/orders/create`,
        {
          department_id: 1,
          patient_name: `${data.firstname || ""} ${data.lastname || ""}`.trim(),
          tov: tovValue, // purpose
          lov: lovValue,
          diagnosis: "",
          // ordertype: "mrecord", // tabs
              ordertype: order.context=='diagnosis'?'Diagnostic Tests':order.context, // tabs
          ordername:order.content, // buttons
          schedule: selectedCard, // t/f-schedule
          // provider: data.linked_provider,
          provider: `${userConfig?.firstname || ""} ${userConfig?.lastname || ""}`,
          status: "CREATED",
          confirm_status: "E", // C/E
          // orderdate:  userdata.created_at?new Date(userdata.created_at).toISOString().split('T')[0]: "Invalid date",
         orderdate: dayjs(dt).isValid()
        ? dayjs(dt).format("YYYY-MM-DD")
        : dayjs().format("YYYY-MM-DD"),
          encounterid: 0,
        }
      );
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
      dispatch(setSearchResults([]));
      fetchsuggestions();
    }
  };
  const editalert = (text, sev) => {
    setIsEditPopupOpen(false);
    setSeverity(sev);
    setAlertMessage(text);
    setOpen(true);
    fetchsuggestions();
  };
  // const fetchsuggestions=async()=>{
  // try {
  //     setLoading(true)
  //     const response =await api.post(`/v1/${practiseid}/orders/get/suggestions`,{
  //         "patientid": data.patientid,
  //         "category": "mrecord",
  //         "searchflag":"",
  //         "searchdate": dt && dt.includes(' ') && !isNaN(Date.parse(dt.split(' ')[0]))
  //         ? dt.split(' ')[0]
  //         : new Date().toISOString().split('T')[0]
  //     })
  //     const selectedsuggestions = await api.post(`/v1/${practiseid}/orders/patient/${data.patientid}/get-orders`, {
  //         "appointmentid": data.appointmentid,
  //         // "orderdate": data.created_at ? new Date(data.created_at).toISOString().split('T')[0] : "Invalid date"
  //          "orderdate": dt && dt.includes(' ') && !isNaN(Date.parse(dt.split(' ')[0]))
  //          ? dt.split(' ')[0]
  //          : new Date().toISOString().split('T')[0]
  //     });
  //       if (selectedsuggestions.status === 200) {
  //         const suggestionList = selectedsuggestions.data?.look || [];
  //         setSelectedSuggestionList(suggestionList);
  //         setGetOrdersData(selectedsuggestions?.data);
  //         setReferals(selectedsuggestions.data?.referrals || [])
  //       }
  //     if(response.status===200){
  // setSuggestionsData(response.data)
  //     }else{
  //         setSuggestionsData([])
  //     }
  // } catch (error) {

  // }finally{
  // setLoading(false)

  // }
  // }
  useEffect(() => {
    fetchsuggestions();
  }, [dt]);
  // const handleClose=async()=>{
  //     try {
  //         const getorder = await getorders()
  //         setLoading(true)
  //         const response=await api.delete(`/v1/${practiseid}/orders/delete/patient/${data.patientid}/notconfirmed`,{
  //             data: {
  //                 // orderdate: data.created_at?new Date(data.created_at).toISOString().split('T')[0]: "Invalid date",
  //                  "orderdate": dt && dt.includes(' ') && !isNaN(Date.parse(dt.split(' ')[0]))
  //                  ? dt.split(' ')[0]
  //                  : new Date().toISOString().split('T')[0]
  //             }})
  //             setTimeout(() => {

  //   if(appointmentId){
  // setShowOrders(false)
  //               }else{
  //               navigate('/landing');
  //               }
  //           }, 2000);
  //           //   if (response.status === 200) {
  //           //     setAlertMessage(response.message)
  //           // setSeverity("success")
  //           // setOpen(true)
  //           //     setTimeout(() => {

  //           //         navigate('/landing'); // Navigate after 2 seconds
  //           //     }, 2000);
  //           // }else{
  //           //   setAlertMessage(response.message)
  //           //   setSeverity("info")
  //           //   setOpen(true)
  //           // }

  //     } catch (error) {
  //         console.log(error)
  //     }finally{
  // setLoading(false)
  // fetchsuggestions()
  //     }
  // }

  // const handleSave=async()=>{
  //     setLoading(true)
  //     try {
  //          const getorder = await getorders('block');

  // const ordersicd = getorder.diagnosis || [];  // Make sure it's an array

  // const icd10Array = ordersicd.map(item => item.icd10);
  // if(!lovValue){
  //     setAlertMessage('Level of visit is not selected')
  //           setSeverity("info")
  //           setOpen(true)
  // }
  // if(!tovValue){
  //    setAlertMessage('Type of visit is not selected')
  //           setSeverity("info")
  //           setOpen(true)
  // }
  // if(tovValue){
  // if(tovValue===getorder?.lovtov[0]?.tov&&lovValue===getorder?.lovtov[0]?.lov){
  // }else{
  //     await api.put(`/v1/${practiseid}/patient/${data.patientid}/orders/lovtov/update`,{
  //           patientname: `${data.firstname || ''} ${data.lastname || ''}`.trim(),
  //       orderdate:
  //                             dt && dt.includes(' ') && !isNaN(Date.parse(dt.split(' ')[0]))
  //                                 ? dt.split(' ')[0]
  //                                 : new Date().toISOString().split('T')[0],
  //   "lov": lovValue,
  //   "ordlist": tovValue,
  //   "task": "VISIT",
  //   "loginuser": userConfig?.username,
  //   "user_role": "ALL"
  //   })

  // }

  // }else{
  //  const createResponse = await api.post(
  //                     `/v1/${practiseid}/patient/${data.patientid}/orders/create`,
  //                     {
  //                         department_id: 1,
  //                         patient_name: `${data.firstname || ''} ${data.lastname || ''}`.trim(),
  //                         tov: tovValue, // purpose
  //                         lov: data.lov,
  //                         diagnosis: '',
  //                         ordertype: 'VISIT', // tabs
  //                         ordername: ' ', // buttons
  //                         schedule: selectedCard, // t/f-schedule
  //                         provider: data.linked_provider,
  //                         status: 'CREATED',
  //                         confirm_status: 'E', // C/E
  //                         orderdate:
  //                             dt && dt.includes(' ') && !isNaN(Date.parse(dt.split(' ')[0]))
  //                                 ? dt.split(' ')[0]
  //                                 : new Date().toISOString().split('T')[0],
  //                         encounterid: 0,

  //                     }
  //                 )
  // }
  // if (
  //   tov2Value !== getorder?.lovtov[0]?.tov2 ||
  //   lov2Value !== getorder?.lovtov[0]?.lov2
  // ) {
  //   // only update if tov2Value exists
  //   tov2Value &&
  //     await api.put(
  //       `/v1/${practiseid}/orders/update/patient/${data.patientid}/secondtovtask`,
  //       {
  //         task: "VISIT",
  //         orderdate:
  //           dt && dt.includes(" ") && !isNaN(Date.parse(dt.split(" ")[0]))
  //             ? dt.split(" ")[0]
  //             : new Date().toISOString().split("T")[0],
  //         lov2: lov2Value,
  //         tov2: tov2Value,
  //       }
  //     );
  // } else {
  //   // both values are same, do nothing
  //   console.log("No update needed, values unchanged.");
  // }
  //         const response= await api.post(`/v1/${practiseid}/patient/${data.patientid}/orders/confirm`,{
  //             "patient_name": `${data.firstname || ''} ${data.lastname || ''}`.trim(),
  //          "createdby": userConfig?.username||'',
  //             // "orderdate": data.created_at?new Date(data.created_at).toISOString().split('T')[0]: "Invalid date",
  //              "orderdate":dt && dt.includes(' ') && !isNaN(Date.parse(dt.split(' ')[0]))
  //              ? dt.split(' ')[0]
  //              : new Date().toISOString().split('T')[0],
  //             "tov": tovValue,
  //             "lov":lovValue,
  //                      diagnosis:icd10Array,
  //             "appointmentid":data.appointmentid,
  //             "token_no": 0,
  //             "confirm_status": "E",
  //             "update_status": "C"
  //           })
  //           if (response.status === 200) {
  //             setAlertMessage(response.message)
  //         setSeverity("success")
  //         setOpen(true)
  //             setTimeout(() => {

  //             if(appointmentId){
  // setShowOrders(false)
  //               }else{
  //               navigate('/landing');
  //               }
  //             }, 2000);
  //         }else{
  //           setAlertMessage(response.message)
  //           setSeverity("info")
  //           setOpen(true)
  //         }
  //     } catch (error) {

  //     }finally{
  // setLoading(false)
  //     }
  // }
  return (
    <>
      <MrecordButtons
        selectedCard={selectedCard}
        userdata={data}
        data={suggestionData}
        selectedSuggestionList={selectedSuggestionList}
        fetchsuggestions={fetchsuggestions}
        loading={loading}
                dt={dt}
      />

      {searchResults.length ? (
        <div className="text-start m-2 text-sm text-[#7e7e7e] text-[13px]">
          Search Suggestions
        </div>
      ) : (
        <></>
      )}
      <div className="flex flex-wrap gap-2 mb-2">
        {searchResults.map((result) => {
          const isSelected = selectedButtons.includes(result.id);

          return (
            <button
              key={result.id}
              className={`px-3 py-1 cursor-pointer border-[1px] border-gray-200 text-xs font-poppins tracking-tight font-thin text-center rounded flex items-center justify-center transition-colors duration-300 ease-in-out ${
                isSelected
                  ? "bg-[#e17954] text-white"
                  : "bg-white text-[#1D2951]"
              }`}
              onClick={() => selectsuggestion(result)}
            >
              {result.content}
              <span
                className="ml-2 px-2 py-[2px] text-xs font-semibold rounded"
                style={{
                  backgroundColor: isSelected ? "#1D2951" : "#1D2951", // Light orange or gray depending on selection
                  color: isSelected ? "white" : "white", // Adjust text color based on selection
                }}
              >
                 {result.context=='diagnosis'?'Diagnostic Tests':result.context}
              </span>
            </button>
          );
        })}
      </div>

      <div className="flex flex-wrap justify-center gap-8 m-4 mt-4">
        {/* Card 1 - Today */}
        <div
          onClick={(event) => {
            event.stopPropagation();
            SetSelectedCard("f");
          }}
          className={`w-[500px] flex flex-col items-start p-3 bg-white rounded-[8px] shadow-md
              transition-all duration-300 ease-in-out
              ${
                expandedCards.today ? "max-h-[80vh]" : "h-[280px] min-h-[280px]"
              }`}
          style={{
            boxShadow:
              selectedCard === "f" ? "0px 0px 10px rgba(0, 0, 0, 0.8)" : "",
          }}
        >
          <div className="flex justify-between w-full mb-2">
            <div className="flex items-center mx-1.5">
              <div className="text-[#000000]">{todayIcon}</div>
              <span className="mx-2 text-[16px] font-medium font-inter text-[#101828]">
                Today
              </span>
              <div
                className={`w-6 h-6 flex items-center justify-center rounded-full text-white text-sm ${
                  allInactive ? "bg-gray-500" : "bg-[#E17954]"
                }`}
              >
                {badgeCount}
              </div>
            </div>

            <div className="w-full flex justify-end">
              <div
                className="cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedEdit("f");
                  setIsEditPopupOpen(true);
                }}
              >
                {penIcon}
              </div>
            </div>
          </div>

          <div className="h-[1px] w-[85%] bg-gray-200 self-center mt-2" />

          <div
            className={`flex flex-col w-full px-3 mt-2 flex-grow
      ${expandedCards.today ? "overflow-visible" : "thin-visible-scrollbar"}
      ${expandedCards.today ? "max-h-none" : "max-h-[240px]"}`}
          >
            {selectedSuggestionList?.filter((d) => d.schedule === "f"&&d.context!== "Tov").length >
              0 || referals?.length > 0 ? (
              [
                ...selectedSuggestionList.filter((d) => d.schedule === "f"&&d.context!== "Tov"),
                ...referals,
              ]
                .sort((a, b) => {
                  const order = { CREATED: 1, COMPLETED: 2, CANCELLEDTASK: 3 };
                  return (order[a.status] || 4) - (order[b.status] || 4);
                })
                // .slice(0, expandedCards.today ? undefined : 3)
                .map((data, index) => (
                  <div
                    key={index}
                    className={`w-full my-2 ${
                      data?.status === "CANCELLEDTASK" ||
                      data?.status === "COMPLETED"
                        ? "opacity-[50%]"
                        : "opacity-100"
                    }`}
                  >
                    <div className="flex items-center gap-3">
                      <div className="shrink-0  mt-[2px]">
                        {data?.status == "CANCELLEDTASK"
                          ? CROSSIcon
                          : data?.status == "COMPLETED"
                          ? COMPLETEDIcon
                          : pendingIcon}
                      </div>

                      <div className="flex flex-col text-left">
                        <span className="text-[12px] font-inter uppercase font-semibold tracking-wide text-[#000000]">
                          {data?.context === "Diagnosis"
                            ? "Diagnostic test"
                            : data?.context || "referrals"}
                        </span>
                        <span className="text-[14px] font-inter text-[#111827]">
                          {data.ordername}
                        </span>
                      </div>
                    </div>
                  </div>
                ))
            ) : (
              <div className="w-full text-center text-[#4B5563] text-[12px]">
                No Today appointments!
              </div>
            )}
          </div>

          <button
            className="ml-auto rounded hover:bg-gray-50 transition
               flex items-center justify-center focus:outline-none"
            onClick={(e) => {
              e.stopPropagation();
              toggleCardExpansion("today");
            }}
            aria-label={expandedCards.today ? "Collapse" : "Expand"}
            title={expandedCards.today ? "Collapse" : "Expand"}
          >
           <span
                        className={`inline-block transition-transform duration-200 `}
                      >
                        { expandedCards.today?collapseIcon:expandIcon}
                      </span>
          </button>
        </div>

        {/* Card 2 - Scheduled */}
        <div
          className={`w-[500px] flex flex-col items-start p-3 bg-white shadow-md rounded-[8px]
              transition-all duration-300 ease-in-out
              ${
                expandedCards.scheduled
                  ? "max-h-[80vh]"
                  : "h-[280px] min-h-[280px]"
              }
              ${
                selectedCard === "t"
                  ? ""
                  : "grayscale opacity-50 pointer-events-none"
              }`}
          style={{
            boxShadow: selectedCard === "t" ? "0px 0px 10px #E17954CC" : "",
          }}
        >
          <div className="flex justify-between w-full mb-2">
            <div className="flex items-center mx-1.5">
              <div className="text-[#000000]">{scheduledIcon}</div>
              <span className="mx-2 text-[16px] font-medium font-inter text-[#101828]">
                Scheduled
              </span>
              <div
                className={`w-6 h-6 flex items-center justify-center rounded-full text-white text-sm ${
                  scheduledCompletedOrCancelled && scheduledItems.length > 0
                    ? "bg-gray-500"
                    : "bg-[#E17954]"
                }`}
              >
                {scheduledBadgeCount}
              </div>
            </div>

            <div className="w-full flex justify-end">
              <div
                className="cursor-pointer"
                onClick={() => {
                  setSelectedEdit("t");
                  setIsEditPopupOpen(true);
                }}
              >
                {penIcon}
              </div>
            </div>
          </div>

          <div className="h-[1px] w-[85%] bg-gray-200 self-center mt-2" />

          <div
            className={`flex flex-col w-full px-3 mt-2 flex-grow
      ${expandedCards.scheduled ? "overflow-visible" : "thin-visible-scrollbar"}
      ${expandedCards.scheduled ? "max-h-none" : "max-h-[240px]"}`}
          >
            {selectedSuggestionList?.filter((data) => data.schedule === "t")
              .length > 0 ? (
              selectedSuggestionList
                ?.filter((data) => data.schedule === "t")
                .sort((a, b) => {
                  const order = { CREATED: 1, COMPLETED: 2, CANCELLEDTASK: 3 };
                  return (order[a.status] || 4) - (order[b.status] || 4);
                })
                // .slice(0, expandedCards.scheduled ? undefined : 3)
                .map((data, index) => (
                  <div
                    key={index}
                    className={`w-full my-2 ${
                      data?.status === "CANCELLEDTASK" ||
                      data?.status === "COMPLETED"
                        ? "opacity-[50%]"
                        : "opacity-100"
                    }`}
                  >
                    <div className="flex items-center gap-3">
                      <div className="shrink-0  mt-[2px]">
                        {data?.status == "CANCELLEDTASK"
                          ? CROSSIcon
                          : data?.status == "COMPLETED"
                          ? COMPLETEDIcon
                          : pendingIcon}
                      </div>

                      <div className="flex flex-col text-left">
                        <span className="text-[12px] font-inter uppercase font-semibold tracking-wide text-[#000000]">
                       {data?.context === "Diagnosis"
                            ? "Diagnostic test"
                            : data?.context || "referrals"}
                        </span>
                        <span className="text-[14px] font-inter text-[#111827]">
                          {data.ordername}
                        </span>
                      </div>
                    </div>
                  </div>
                ))
            ) : (
              <div className="w-full text-center text-[#4B5563] text-[12px]">
                No upcoming appointments!
              </div>
            )}
          </div>

          <button
            className="ml-auto rounded hover:bg-gray-50 transition
               flex items-center justify-center focus:outline-none"
            onClick={(e) => {
              e.stopPropagation();
              toggleCardExpansion("scheduled");
            }}
            aria-label={expandedCards.scheduled ? "Collapse" : "Expand"}
            title={expandedCards.scheduled ? "Collapse" : "Expand"}
          >
              <span
                        className={`inline-block transition-transform duration-200 `}
                      >
                        {   expandedCards.scheduled ?collapseIcon:expandIcon}
                      </span>
          </button>
        </div>

        {/* Card 3 - Prescriptions */}
        <div
          className={`w-[500px] flex flex-col items-start p-3 bg-white rounded-[8px] shadow-md
              transition-all duration-300 ease-in-out
              ${
                expandedCards.prescriptions
                  ? "max-h-[80vh]"
                  : "h-[280px] min-h-[280px]"
              }`}
        >
          <div className="flex justify-between w-full mb-2">
            <div className="flex items-center mx-1.5">
              <div className="text-[#000000]">{prescriptionIcon}</div>
              <span className="mx-2 text-[16px] font-medium font-inter text-[#101828]">
                PRESCRIPTIONS
              </span>
              <div className="w-6 h-6 flex items-center justify-center bg-[#E17954] rounded-full text-white text-sm">
                {prescriptionBadgeCount}
              </div>
            </div>

            <div className="w-full flex gap-2 justify-end">
              <div
                className="cursor-pointer"
                onClick={() => setNewRxPopup(true)}
              >
                {RXIcon}
              </div>
              <div
                className="cursor-pointer"
                onClick={() => {
                  setSelectedEdit("");
                  setIsEditPopupOpen(true);
                }}
              >
                {penIcon}
              </div>
            </div>
          </div>

          <div className="h-[1px] w-[85%] bg-gray-200 self-center mt-2" />
          <div
            className={`flex flex-col w-full px-3 mt-2 flex-grow
      ${expandedCards.prescriptions ? "overflow-visible" : "thin-visible-scrollbar"}
      ${expandedCards.prescriptions ? "max-h-none" : "max-h-[240px]"}`}
          >
            {getordersData?.rx_recipe?.length > 0 ? (
              getordersData?.rx_recipe?.map((data, index) => (
                <div key={index} className="w-full my-2">
                  <div className="flex items-center gap-3">
                    <div className="shrink-0  mt-[2px]">{COMPLETEDIcon}</div>

                    <div className="flex flex-col text-left">
                      <span className="text-[12px] font-inter uppercase font-semibold tracking-wide text-[#000000]">
                        PRESCRIPTIONS
                      </span>
                      <span className="text-[14px] font-inter text-[#111827]">
                        {data.medicationname} -{" "}
                        {`${data.dosage_qty} ${data.dosage_qty_unit} ${data.frequency} ${data.duration}`}
                      </span>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="w-full text-center text-[#4B5563] text-[12px]">
                No active prescriptions!
              </div>
            )}
          </div>

          <button
            className="ml-auto rounded hover:bg-gray-50 transition
               flex items-center justify-center focus:outline-none"
            onClick={(e) => {
              e.stopPropagation();
              toggleCardExpansion("prescriptions");
            }}
            aria-label={expandedCards.prescriptions ? "Collapse" : "Expand"}
            title={expandedCards.prescriptions ? "Collapse" : "Expand"}
          >
             <span
                        className={`inline-block transition-transform duration-200 `}
                      >
                        {   expandedCards.prescriptions  ?collapseIcon:expandIcon}
                      </span>
          </button>
        </div>

        {/* Card 4 - Notes */}
        <div
          className={`w-[500px] flex flex-col items-start p-3 bg-white rounded-[8px] shadow-md
              transition-all duration-300 ease-in-out
              ${
                expandedCards.notes ? "max-h-[80vh]" : "h-[280px] min-h-[280px]"
              }`}
        >
          <div className="flex justify-between w-full mb-2">
            <div className="flex items-center mx-1.5">
              <div className="text-[#000000]">{notesIcon}</div>
              <span className="mx-2 text-[16px] font-medium font-inter text-[#101828]">
                NOTES
              </span>
              <div className="w-6 h-6 flex items-center justify-center bg-[#E17954] rounded-full text-white text-sm">
                {notesBadgeCount}
              </div>
            </div>

            <div className="w-full flex gap-2 justify-end">
              <div
                className="cursor-pointer"
                onClick={() => setAddNotesPopup(true)}
              >
                {RXIcon}
              </div>
              <div
                className="cursor-pointer"
                onClick={() => {
                  setSelectedEdit("");
                  setIsEditPopupOpen(true);
                }}
              >
                {penIcon}
              </div>
            </div>
          </div>

          <div className="h-[1px] w-[85%] bg-gray-200 self-center mt-2" />

          <div
            className={`flex flex-col w-full px-3 mt-2 flex-grow
      ${expandedCards.notes ? "overflow-visible" : "thin-visible-scrollbar"}
      ${expandedCards.notes ? "max-h-none" : "max-h-[240px]"}`}
          >
            {getordersData?.notes?.length > 0 ? (
              getordersData?.notes?.map((data, index) => (
                <div key={index} className="w-full my-2">
                  <div className="flex flex-col text-left">
                    <span className="text-[14px] font-inter text-[#111827]">
                      {data.ordername}
                    </span>
                  </div>
                </div>
              ))
            ) : (
              <div className="w-full text-center text-[#4B5563] text-[12px]">
                No notes available!
              </div>
            )}
          </div>

          <button
            className="ml-auto rounded hover:bg-gray-50 transition
               flex items-center justify-center focus:outline-none"
            onClick={(e) => {
              e.stopPropagation();
              toggleCardExpansion("notes");
            }}
            aria-label={expandedCards.notes ? "Collapse" : "Expand"}
            title={expandedCards.notes ? "Collapse" : "Expand"}
          >
           
                <span
                        className={`inline-block transition-transform duration-200 `}
                      >
                        {   expandedCards.notes ?collapseIcon:expandIcon}
                      </span>
          </button>
        </div>
      </div>

      {/* <div className="w-full flex justify-end gap-4 sm:gap-4 mt-4">

                    <button
                    onClick={()=>handleClose()}
                        className="rounded w-[100px] bg-white cursor-pointer text-black border-2 border-gray-200 py-2 px-4 transition duration-300 ease-in-out  hover:bg-gray-800">
                        Close
                    </button>

                    <button
onClick={()=>handleSave()}
                        className="rounded w-[100px] bg-black text-white py-2 px-4 transition duration-300 ease-in-out hover:bg-gray-800">
                        Save
                    </button>
                </div> */}
      <EditPopup
        fetchsuggestions={fetchsuggestions}
        selectedEdit={selectedEdit}
        editalert={editalert}
        isOpen={isEditPopupOpen}
        onClose={() => setIsEditPopupOpen(false)}
        getordersData={getordersData}
                dt={dt}
      />
      <AddNotesPopup
        fetchsuggestions={fetchsuggestions}
        userdata={data}
        isOpen={isAddnotesPopup}
        onClose={() => setAddNotesPopup(false)}
                dt={dt}
      />
      <NewRxPopup
        fetchsuggestions={fetchsuggestions}
        isOpen={isnewRxpopup}
                dt={dt}
        onClose={() => setNewRxPopup(false)}
      />
      <Backdrop
        sx={{
          color: "secondary.main", // Sets the CircularProgress color to secondary
          backgroundColor: "rgba(255, 255, 255, 0.5)", // Semi-transparent white background
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={loading}
      >
        <CircularProgress color="secondary" />
      </Backdrop>

      <ToastMessage
        message={alertmessage}
        severity={severity}
        open={open}
        handleClose={handlealert}
      />
    </>
  );
};
export default MedicalRecordsTab;
